module.exports = __webpack_public_path__ + "static/media/7.8eb8c819.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/7.mp3
// module id = 86
// module chunks = 0